<template>
    <div id="d-group-profile-detail">
        <div class="grid pb-0">
            <div class="grid-title">
                <h4 class="mr-auto">{{ $t("_GROUP.DETAIL") }}</h4>
                <v-btn class="mt-0 mr-3" depressed color="warning" @click="$router.back()">
                    <i class="icon-back-ic mr-2"></i> {{ $t("BACK") }}
                </v-btn>
            </div>
            <div class="grid-body border-top-unset list-booking-group">
                <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
                <div class="p-3" v-else>
                    <v-form ref="form-info" lazy-validation>
                        <div>
                            <label class="label-title">{{ $t("_GROUP.INFO") }}</label>
                            <v-row class="mt-3">
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.GROUP_PROFILE_NAME") }} *</label>
                                    <v-text-field v-model="editedItem.nameVi" :rules="ruleName" outlined dense counter
                                        maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.GROUP_PROFILE_NAME_OTHER") }} </label>
                                    <v-text-field v-model="editedItem.alias" outlined dense counter maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.COMPANY_NAME") }} *</label>
                                    <v-text-field v-model="editedItem.company" outlined dense counter maxlength="250"
                                        :rules="ruleName">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <label class="label-input">{{ $t("_REGISTER.WEBSITE") }}</label>
                                    <v-text-field v-model="editedItem.website" outlined dense counter maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.DESCRIPTION") }}</label>
                                    <v-textarea v-model="editedItem.descriptionVi" outlined dense counter maxlength="500">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider />
                        <div>
                            <label class="label-title">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
                            <v-row class="mt-3">
                                <v-col cols="1" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.TITLE") }}</label>
                                    <v-autocomplete v-model="editedItem.contactTitle" :items="titles" outlined dense
                                        class="c-title" item-text="text" item-value="value"></v-autocomplete>
                                </v-col>
                                <v-col cols="2" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.CONTACT_NAME") }} *</label>
                                    <v-text-field v-model="editedItem.contactName" :rules="ruleName" outlined dense counter
                                        maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input"> Email* </label>
                                    <v-text-field v-model="editedItem.contactEmail" outlined dense counter
                                        :rules="ruleEmail" maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.PHONE_NUMBER") }} *</label>
                                    <v-text-field v-model="editedItem.contactPhone" outlined dense counter
                                        :rules="rulePhone.concat(ruleRequied)" maxlength="100">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.PHONE_NUMBER_OTHER") }}</label>
                                    <v-text-field v-model="editedItem.contactMobile" outlined dense counter
                                        :rules="rulePhone" maxlength="100">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("COUNTRY") }}</label>
                                    <vue-autosuggest class="input-suggest input-suggest-booking v-text-field--outlined"
                                        v-model="editedItem.contactCountry" componentAttrIdAutosuggest="demo-autosuggest"
                                        :section-configs="sectionConfigs" :should-render-suggestions="
                                            (size, loading) => size >= 0 && !loading && editedItem.contactCountry !== ''
                                        " @selected="$event => editedItem.contactCountry = $event.item" :suggestions="[
    {
        data: select.countries
            .filter((p) => {
                return p.name.toLowerCase().indexOf(editedItem.contactCountry ? editedItem.contactCountry.toLowerCase() : '') > -1;
            })
            .map((e) => e.name),
    },
]" ref="autocomplete">
                                        <template slot-scope="{ suggestion, index, cs }">
                                            <div>{{ suggestion.item }}</div>
                                        </template>
                                    </vue-autosuggest>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("CITY") }}</label>
                                    <vue-autosuggest class="input-suggest input-suggest-booking v-text-field--outlined"
                                        v-model="editedItem.contactCity" componentAttrIdAutosuggest="demo-autosuggest"
                                        :section-configs="sectionConfigs" :should-render-suggestions="
                                            (size, loading) => size >= 0 && !loading && editedItem.contactCity !== ''
                                        " @selected="$event => editedItem.contactCity = $event.item" :suggestions="[
    {
        data: select.cities
            .filter((p) => {
                return p.name.toLowerCase().indexOf(editedItem.contactCity ? editedItem.contactCity.toLowerCase() : '') > -1;
            })
            .map((e) => e.name),
    },
]" ref="autocomplete">
                                        <template slot-scope="{ suggestion, index, cs }">
                                            <div>{{ suggestion.item }}</div>
                                        </template>
                                    </vue-autosuggest>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("DISTRICT") }}</label>
                                    <vue-autosuggest class="input-suggest input-suggest-booking v-text-field--outlined"
                                        v-model="editedItem.contactDistrict" componentAttrIdAutosuggest="demo-autosuggest"
                                        :section-configs="sectionConfigs" :should-render-suggestions="
                                            (size, loading) => size >= 0 && !loading && editedItem.contactDistrict !== ''
                                        " @selected="$event => editedItem.contactDistrict = $event.item" :suggestions="[
    {
        data: select.districts
            .filter((p) => {
                return p.name.toLowerCase().indexOf(editedItem.contactDistrict ? editedItem.contactDistrict.toLowerCase() : '') > -1;
            })
            .map((e) => e.name),
    },
]" ref="autocomplete">
                                        <template slot-scope="{ suggestion, index, cs }">
                                            <div>{{ suggestion.item }}</div>
                                        </template>
                                    </vue-autosuggest>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("ADDRESS") }}</label>
                                    <v-text-field v-model="editedItem.contactAddress" outlined dense counter
                                        maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.DESCRIPTION") }}</label>
                                    <v-textarea v-model="editedItem.contactDescription" outlined dense counter
                                        maxlength="500">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider />
                        <div>
                            <label class="label-title">{{ $t("_GROUP.INFO_MANAGE") }}</label>
                            <v-row class="mt-3">

                                <v-col cols="1" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.TITLE") }}</label>
                                    <v-autocomplete v-model="editedItem.managerTitle" :items="titles" outlined dense
                                        class="c-title" item-text="text" item-value="value"></v-autocomplete>
                                </v-col>
                                <v-col cols="2" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.MANAGE_NAME") }}</label>
                                    <v-text-field v-model="editedItem.managerName" outlined dense counter maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input"> Email </label>
                                    <v-text-field v-model="editedItem.managerEmail" :rules="ruleEmailNotRequied" outlined
                                        dense counter maxlength="250">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.PHONE_NUMBER") }} </label>
                                    <v-text-field v-model="editedItem.managerPhone" outlined dense counter
                                        :rules="rulePhone" maxlength="100">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.PHONE_NUMBER_OTHER") }}</label>
                                    <v-text-field v-model="editedItem.managerMobile" outlined dense counter
                                        :rules="rulePhone" maxlength="100">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <label class="label-input">{{ $t("_GROUP.DESCRIPTION") }}</label>
                                    <v-textarea v-model="editedItem.managerDescription" outlined dense counter
                                        maxlength="500">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider />
                        <div>
                            <label class="label-title">{{ $t("_GROUP.ASSIGN") }}</label>
                            <v-row>
                                <v-col sm="3">
                                    <v-card style="min-height: 350px">
                                        <v-card-title class="fs-12 text-uppercase">{{ $t("UNASSIGN") }}</v-card-title>
                                        <div class="pl-2 pr-2">
                                            <v-text-field prepend-inner-icon="mdi-magnify"
                                                :placeholder="$t('_HOTEL_CHAIN.SEARCH')" v-model="searchUnApply"
                                                @input="searchOnUnApply" outlined dense></v-text-field>
                                        </div>
                                        <v-list class="mt-2" flat subheader three-line>
                                            <v-list-item-group v-model="unApplySetting" multiple
                                                active-class="grey lighten-3" style="max-height: 230px; overflow: auto">
                                                <template v-for="(item, index) in searchedUnApply">
                                                    <v-list-item>
                                                        <template v-slot:default="{ active }">
                                                            <v-list-item-action>
                                                                <v-checkbox :input-value="active"></v-checkbox>
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title v-text="item.nameVi"
                                                                    :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-list-item>
                                                </template>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card>
                                    <p class="mb-0 mt-2">
                                        {{ searchedUnApply.length }}/{{ unApplyHotel.length }}
                                        {{ $t("ITEMS_SHOWING") }}
                                    </p>
                                </v-col>
                                <v-col sm="1" class="d-flex align-center justify-content-center">
                                    <div>
                                        <v-btn class="d-block" @click="leftToRight">
                                            <v-icon>navigate_next</v-icon>
                                        </v-btn>
                                        <v-btn class="d-block mt-3" @click="rightToLeft">
                                            <v-icon>chevron_left</v-icon>
                                        </v-btn>
                                        <v-btn class="d-block mt-3" @click="allLeftToRight">
                                            <v-icon>keyboard_double_arrow_right</v-icon>
                                        </v-btn>
                                        <v-btn class="d-block mt-3" @click="allRightToLeft">
                                            <v-icon>keyboard_double_arrow_left</v-icon>
                                        </v-btn>
                                        <v-btn class="d-block mt-3" @click="compare">
                                            <v-icon>compare_arrows</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col sm="3">
                                    <v-card style="min-height: 350px">
                                        <v-card-title class="fs-12 text-uppercase">{{ $t("ASSIGN") }}</v-card-title>
                                        <div class="pl-2 pr-2">
                                            <v-text-field prepend-inner-icon="mdi-magnify"
                                                :placeholder="$t('_HOTEL_CHAIN.SEARCH')" v-model="searchApply"
                                                @input="searchOnApply" outlined dense></v-text-field>
                                        </div>
                                        <v-list class="mt-2" flat subheader three-line>
                                            <v-list-item-group v-model="applySetting" multiple active-class="grey lighten-3"
                                                style="max-height: 230px; overflow: auto">
                                                <template v-for="(item, index) in searchedApply">
                                                    <v-list-item>
                                                        <template v-slot:default="{ active }">
                                                            <v-list-item-action>
                                                                <v-checkbox :input-value="active"></v-checkbox>
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title v-text="item.nameVi"
                                                                    :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-list-item>
                                                </template>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card>
                                    <p class="mb-0 mt-2">
                                        {{ searchedApply.length }}/{{ applyHotel.length }} {{ $t("ITEMS_SHOWING") }}
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                        <b-row>
                            <v-col>
                                <v-checkbox v-model="editedItem.overwrite" :label="$t('ALLOW_OVERWRITING_INFOMATION_DOWN')"
                                    class="mt-0"></v-checkbox>
                            </v-col>
                            <v-col>
                                <div class="btn-bottom">
                                    <v-btn class="mt-0 mr-3" depressed color="warning" @click="$router.back()">
                                        <i class="icon-back-ic mr-2"></i> {{ $t("BACK") }}
                                    </v-btn>
                                    <v-btn color="primary" class="pr-10 pl-10" @click="save()" :disabled="disableSaveBtn">{{
                                        $t("SAVE") }}</v-btn>
                                </div>
                            </v-col>
                        </b-row>
                    </v-form>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
#d-group-profile-detail {
    .v-input .v-text-field__details {
        display: block;

        .v-counter {
            text-align: right;
            margin-top: 5px;
        }
    }
}
</style>

<script>
import { service } from "@/_services/Group/group.service.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { systemService } from "@/_services/system-data.service.js";
import {
    _alert
} from "@/_helpers/function.js";
import store from "@/plugins/store";
const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
    if (term) {
        return items.filter((item) => toLower(item.nameVi).includes(toLower(term)));
    }

    return items;
};
export default {
    components: {
        "delete-dialog": DeleteDialog,
    },
    data() {
        return {
            isLoading: true,
            editedItem: {
                nameVi: "",
                groupProfileCode: "",
                alias: null,
                company: "",
                website: null,
                descriptionVi: "",
                contactName: "",
                contactEmail: "",
                contactPhone: "",
                contactMobile: "",
                contactCountry: null,
                contactCity: null,
                contactDistrict: null,
                managerName: null,
                managerEmail: null,
                managerPhone: null,
                managerMobile: null,
                contactDescription: null,
                contactAddress: "",
                bookingGroupDTOS: [],
                totalBookingGroup: 0,
                managerDescription: null,
                overwrite: false
            },
            select: {
                countries: [],
                cities: [],
                districts: [],
                wards: []
            },
            locations: [],
            lang: this.$i18n.locale,
            isEdit: false,

            hotelchain: [],
            applyHotel: [],
            unApplyHotel: [],
            searchApply: null,
            searchedApply: [],
            searchedUnApply: [],
            disableSaveBtn: false,
            unApplySetting: [],
            applySetting: [],
            titles: [],
            sectionConfigs: {
                default: {
                    limit: 4,
                    ulClass: { "data-darren": true },
                    liClass: { "elf-row": true },
                },
                Elf: {
                    limit: 6,
                },
            },
        }
    },
    watch: {

    },
    created() {
        this.getLocation();
    },
    methods: {
        async initialize() {
            this.isLoading = true
            let id = this.$route.params.code
            if (id !== 0) {
                this.isEdit = true;
                service.getDetailProfile(id).then((res) => {
                    this.editedItem = res.data;
                    this.editedItem.overwrite = false;
                }).finally(() => (this.getbookingGroups()));
            } else {
                this.isEdit = false
                this.getbookingGroups()
            }

        },
        async getLocation() {
            await systemService.getLocations().then(res => {
                this.locations = res.data;
                this.select.countries = res.data
                    .filter(x => !x.parent)
                    .map(x => {
                        return {
                            name: x.i18ns.find(x => x.lang == this.defaultI18n)
                                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                                : ""
                        };
                    });
                this.select.cities = this.locations
                    .filter(x => x.locType == 1)
                    .map(x => {
                        return {
                            name: x.i18ns.find(x => x.lang == this.defaultI18n)
                                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                                : ""
                        };
                    });
                this.select.districts = this.locations
                    .filter(x => x.locType == 2)
                    .map(x => {
                        return {
                            name: x.i18ns.find(x => x.lang == this.defaultI18n)
                                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                                : ""
                        };
                    });
                this.initialize()
            });
        },
        async getTitle() {
            await service.getTitle().then(res => {
                if (res.responseCode == 0) {
                    this.titles = res.data.map(x => Object.assign({}, {
                        text: x,
                        value: x
                    }));

                }
            }).finally(() => (this.isLoading = false));
        },
        async getbookingGroups() {
            const body = {
                limit: null,
                offset: null,
                searchBy: 'BOOKING_GROUP_NAME',
                from: null,
                to: null,
                code: null,
                status: null,
            };
            await service.getAllBooking(body).then(res => {
                if (res.responseCode == 0) {
                    this.hotelchain = res.data;
                    if (this.editedItem.bookingGroupDTOS.length > 0) {
                        this.applyHotel = this.hotelchain.filter((e) =>
                            this.editedItem.bookingGroupDTOS.includes(e.id)
                        );
                        this.unApplyHotel = this.hotelchain.filter(
                            (e) => !this.editedItem.bookingGroupDTOS.includes(e.id)
                        );

                        this.searchedApply = this.hotelchain.filter((e) =>
                            this.editedItem.bookingGroupDTOS.includes(e.id)
                        );
                        this.searchedUnApply = this.hotelchain.filter(
                            (e) => !this.editedItem.bookingGroupDTOS.includes(e.id)
                        );
                    } else {
                        this.unApplyHotel = [...this.hotelchain];
                        this.clearSearch();
                    }
                }
            }).finally(() => (this.getTitle()));
        },
        clearSearch() {
            this.searchApply = null;
            this.searchUnApply = null;
            this.searchOnApply();
            this.searchOnUnApply();
        },
        searchOnApply() {
            this.searchedApply = searchByName(this.applyHotel, this.searchApply);
        },
        searchOnUnApply() {
            this.searchedUnApply = searchByName(this.unApplyHotel, this.searchUnApply);
        },
        leftToRight() {
            if (this.unApplySetting.length > 0) {
                this.unApplySetting.forEach((e) => {
                    this.applyHotel.push(this.searchedUnApply[e]);
                });
                this.unApplyHotel = this.hotelchain.filter(
                    (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
                );
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },

        rightToLeft() {
            if (this.applySetting.length > 0) {
                this.applySetting.forEach((e) => {
                    this.unApplyHotel.push(this.searchedApply[e]);
                });
                this.applyHotel = this.hotelchain.filter(
                    (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
                );
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },
        allLeftToRight() {
            if (this.searchedUnApply.length > 0) {
                this.searchedUnApply.forEach((e) => {
                    this.applyHotel.push(e);
                });
                this.unApplyHotel = this.hotelchain.filter(
                    (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
                );
                this.searchedUnApply = [];
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },
        allRightToLeft() {
            if (this.searchedApply.length > 0) {
                this.searchedApply.forEach((e) => {
                    this.unApplyHotel.push(e);
                });
                this.applyHotel = this.hotelchain.filter(
                    (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
                );
                this.searchedApply = [];
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },
        compare() {
            const apply = Array.from(new Set(this.applyHotel.map(JSON.stringify))).map(
                JSON.parse
            );
            const unApply = Array.from(new Set(this.unApplyHotel.map(JSON.stringify))).map(
                JSON.parse
            );
            this.applyHotel = [...unApply];
            this.unApplyHotel = [...apply];
            this.applySetting = [];
            this.unApplySetting = [];
            this.clearSearch();
        },

        save() {
            let form_validate = this.$refs['form-info'].validate();

            if (!form_validate) {
                store.commit("alert/display", {
                    message: this.$t('_VALIDATE.REQUIRED'),
                    error: true,
                    success: false,
                });
                const el = document.querySelector(".v-messages.error--text:first-of-type");
                el.scrollIntoView();
                return false;
            }

            if (form_validate) {
                let updatedData = Object.assign({}, this.editedItem);
                updatedData.bookingGroupDTOS = this.applyHotel.map((item) => item.id);
                if (this.editedItem.id) {
                    this.disableSaveBtn = true;
                    service.updateGroupProfile(updatedData).then((res) => {
                        _alert(res, this.$t(res.data), false);
                        this.disableSaveBtn = false;
                    });
                } else {
                    this.disableSaveBtn = true;
                    service.createGroupProfile(updatedData).then((res) => {
                        if (res.responseCode == 0) {
                            _alert(res, this.$t("CREATE_SUCCESS"), false);
                        }
                        let vm = this;
                        setTimeout(function () {
                            vm.$router.push({ name: "profilesGroup" });
                        }, 1000);
                        if (res.responseCode != 0) {
                            this.disableSaveBtn = false;
                            _alert(res, this.$t(res.data), false);
                        }
                    });
                }
            }
        }
    },
}
</script>